export default "__VITE_ASSET__mbezkBPK__"